.container {
	display: flex;
	align-items: center;
	padding: 8px;
	color: var(--ds-text, var(--adg3-color-N800));
}

.avatarContainer {
	min-width: 18px;
	min-height: 18px;
	margin-right: 5px;
}

.nameContainer {
	text-overflow: ellipsis;
	white-space: nowrap;
	overflow-x: hidden;
}
